import { CoreDataContext } from "../components/Layout";
import CustomLink from "./CustomLink";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Menu.module.css";
import { useContext } from "react";

export default function Menu({ isMenuOpen, pathName }) {
  const { aboutPage, contactPage, projectListPage, venturesPage } =
    useContext(CoreDataContext);

  return (
    <nav
      className={classNames({
        [styles.Menu]: true,
        [styles.active]: isMenuOpen,
      })}
    >
      <div className={styles.menuInner}>
        <CustomLink
          href={projectListPage.url}
          className={classNames({
            [styles.MenuItem]: true,
            [styles.active]: pathName.includes(projectListPage.url),
          })}
        >
          Work
        </CustomLink>
        <CustomLink
          href={aboutPage.url}
          className={classNames({
            [styles.MenuItem]: true,
            [styles.active]: aboutPage.url === pathName,
          })}
        >
          About
        </CustomLink>
        {venturesPage.url && (
          <CustomLink
            href={venturesPage.url}
            className={classNames({
              [styles.MenuItem]: true,
              [styles.active]: venturesPage.url === pathName,
            })}
          >
            Ventures
          </CustomLink>
        )}

        <CustomLink
          href={contactPage.url}
          className={classNames({
            [styles.MenuItem]: true,
            [styles.active]: contactPage.url === pathName,
          })}
        >
          Contact
        </CustomLink>
      </div>
    </nav>
  );
}

Menu.propTypes = {
  isMenuOpen: PropTypes.bool.isRequired,
  pathName: PropTypes.string,
};
